import React, { useCallback, useReducer } from 'react';
import {
	createCredentialsInitialState,
	CreateCredentialsContext,
	TTypeOfModalWindow,
} from './createCredentialsContext';
import { createCredentialsReducer } from './createCredentialsReducer';
import { CreateCredentialsActionTypes } from './createCredentialsActions';
import { ICreateCredentials } from 'types';

export const CreateCredentialsState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(createCredentialsReducer, createCredentialsInitialState);

	const changeCredentialName = useCallback((value: string) => {
		dispatch({
			type: CreateCredentialsActionTypes.CHANGE_CREDENTIAL_NAME,
			payload: {
				credentialName: value,
			},
		});
	}, []);

	const changeApiKey = useCallback((value: string) => {
		dispatch({
			type: CreateCredentialsActionTypes.CHANGE_API_KEY,
			payload: {
				apiKey: value,
			},
		});
	}, []);

	const changeApiSecret = useCallback((value: string) => {
		dispatch({
			type: CreateCredentialsActionTypes.CHANGE_API_SECRET,
			payload: {
				apiSecret: value,
			},
		});
	}, []);

	const setDataForSubmit = useCallback((value: Nullable<ICreateCredentials>) => {
		dispatch({
			type: CreateCredentialsActionTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	}, []);

	const changeTypeOfModalWindow = useCallback((value: TTypeOfModalWindow) => {
		dispatch({
			type: CreateCredentialsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	}, []);

	const resetFields = useCallback(() => dispatch({ type: CreateCredentialsActionTypes.RESET_FIELDS }), []);

	return (
		<CreateCredentialsContext.Provider
			value={{
				changeCredentialName,
				changeApiKey,
				changeApiSecret,
				setDataForSubmit,
				changeTypeOfModalWindow,
				resetFields,
				credentialName: state.credentialName,
				apiKey: state.apiKey,
				apiSecret: state.apiSecret,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</CreateCredentialsContext.Provider>
	);
};
